export enum SortField {
  NAME = 'name',
  RATE = 'rate',
  APPLIED = 'applied'
}

export enum SortDirection {
  ASC = 'asc',
  DESC = 'desc'
}